import { StyleSheet } from 'aphrodite'

import main from './main'
import list from './list'
import headers from './headers'

export default {
  main: StyleSheet.create(main),
  list: StyleSheet.create(list),
  headers: StyleSheet.create(headers)
}



// WEBPACK FOOTER //
// ./src/components/partials/Sitemap/style/index.js